import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { parse } from 'qs';

// Components
import { LocaleProvider, message } from 'antd';
import { Provider } from 'react-redux';
import Routes from './Routes';
import { SplashView } from './components/common/SplashView';

// Store
import configureStore from './configureStore';

// Actions
import { onAuthIsAuthorized, setUserProfile, removeUserData } from './data/auth/actions';

import { onLanguageChange } from './data/app/actions';
import keycloak from './utils/keycloak';
import { AFTER_LOGOUT_REDIRECT } from './utils';
// Helpers
import { strings } from './localization/index';

import styles from '../assets/less/index.less'; // eslint-disable-line no-unused-vars

import { ConnectedRouter } from 'connected-react-router';

const getLangeFromQuery = () => {
    const query = parse(window.location.search, { ignoreQueryPrefix: true });   
    return query.lang;
};

const getRegisterFromQuery = () => {
    const query = parse(window.location.search, { ignoreQueryPrefix: true });
    return query.register;
};

const getAuthTokenFromPath = () => {
    const path = parse(window.location.search, { ignoreQueryPrefix: true });    
    return path.authToken;
};

class Root extends Component {
    constructor(props) {
        super(props);        
        this.state = { store: null, momentLocale: null, history: null };
    }


    async componentWillMount() {

        const hostname = window && window.location && window.location.hostname;

        console.log("hostname: ", hostname);

        configureStore(configuredStore => {
            const { dispatch, getState } = configuredStore.store;
            const queryLang = getLangeFromQuery();

            if (queryLang) {
                dispatch(onLanguageChange(queryLang));
            }

            const persistedLang = getState().app.get('lang');
            strings.setLanguage(persistedLang || 'en');
            let momentLocale;            

            switch (getState().app.get('lang')) {
                case 'en':
                    // eslint-disable-next-line global-require
                    momentLocale = require('antd/lib/locale-provider/en_US');
                    break;
                case 'sk':
                    // eslint-disable-next-line global-require
                    momentLocale = require('antd/lib/locale-provider/sk_SK');
                    break;
                case 'de':
                    // eslint-disable-next-line global-require
                    momentLocale = require('antd/lib/locale-provider/de_DE');
                    break;
                case 'zh':
                    // eslint-disable-next-line global-require
                    momentLocale = require('antd/lib/locale-provider/zh_CN');
                    break;
                default:
                    // eslint-disable-next-line global-require
                    momentLocale = require('antd/lib/locale-provider/en_US');
                    break;
            }

            this.setState({
                store: configuredStore.store,
                history: configuredStore.history,
                momentLocale
            });

            let tokens = keycloak.getTokenStorage();

            const authToken = getAuthTokenFromPath();

            if (authToken) {

                keycloak.setTokenStorageForMobileRoute(authToken);

                tokens = keycloak.getTokenStorage();

                dispatch(setUserProfile({})).then(() => {
                    this.setState({ isAuthenticated: true });
                    dispatch(onAuthIsAuthorized(true));
                });

                return;
            }

            keycloak
                .init({ onLoad: 'check-sso', checkLoginIframe: false, ...tokens })
                .success(authenticated => {
                    const register = getRegisterFromQuery();
                    if (register) {
                        let registerUrl = keycloak.createRegisterUrl();
                        // remove register query params from redirect uri
                        registerUrl = registerUrl.replace('register%3Dtrue&', '');
                        window.location.href = registerUrl;
                    } else if (authenticated) {
                        keycloak.setTokenStorage();
                        keycloak
                            .loadUserProfile()
                            .success(profile => {
                                dispatch(setUserProfile(profile)).then(() => {
                                    this.setState({ isAuthenticated: true });
                                    dispatch(onAuthIsAuthorized(authenticated));
                                });
                            })
                            .error(() => {
                                console.log('Unable to access user profile', 3);
                                keycloak.removeTokenStorage();
                                keycloak.logout({
                                    redirectUri: AFTER_LOGOUT_REDIRECT
                                });
                            });
                    } else if (!authenticated) {
                        keycloak.removeTokenStorage();
                        dispatch(removeUserData());
                        keycloak.login({ locale: persistedLang, kcLocale: persistedLang });
                    }
                })
                .error(() => {
                    message.error('Unable to login', 3);
                    keycloak.removeTokenStorage();
                    keycloak.logout({
                        redirectUri: AFTER_LOGOUT_REDIRECT
                    });
                });
        });
    }

    logout = () => {
        keycloak.removeTokenStorage();
        keycloak.logout({
            redirectUri: AFTER_LOGOUT_REDIRECT
        });
    };

    render() {
        const { store, history, momentLocale, isAuthenticated } = this.state;

        if (store === null || history === null || !isAuthenticated) {
            return <SplashView />;
        }

        return (
            <Provider store={store}>
                <LocaleProvider locale={momentLocale}>
                    <ConnectedRouter history={history}>
                        <Routes logout={this.logout} />
                    </ConnectedRouter>
                </LocaleProvider>
            </Provider>
        );
    }
}
// Step 1. Get document element by ID
const rootNode = document.getElementById('watt-analytics-react');

// Step 2. Render Root component to document root node
ReactDOM.render(<Root />, rootNode);
